module.exports = __webpack_public_path__ + "media/images/my_apps/pathophys_fo_app_icon-71e65e8453268502ac94f89e35660d4a.png";